import React from "react";
import "./StartupCard.scss"
const StartupCard = ({ item, index }) => {
    return (
        <div className="StartupCard">
            <div className="StartupCard-image">
                <div className="StartupCard-image-number">
                    {index}
                </div>
                <img alt="" src={item.image} className="StartupCard-image-img" />

            </div>
            <div className="StartupCard-header">
                {item.header}
            </div>
            <div className="StartupCard-subheader">
                {item.content}
            </div>
        </div>
    )
}
export default StartupCard